module.exports = __webpack_public_path__ + "static/media/logo4.a0a40cab.png";